import {initializeApp} from 'firebase/app';
import {getAuth} from 'firebase/auth';
import {getStorage} from 'firebase/storage';
import {
  connectFunctionsEmulator,
  getFunctions,
  httpsCallable,
} from 'firebase/functions';
import type {
  GetZoomAccountUsersRequest,
  GetZoomAccountUsersResponse,
  ZoomOAuthRequest,
} from '@cip/core/zoom';

const firebaseConfig = {
  apiKey: 'AIzaSyC5R06hZdnowglrzoD_RVw7EVH3nSGE0Yo',
  authDomain: 'codeinplace-production.firebaseapp.com',
  projectId: 'codeinplace-production',
  storageBucket: 'codeinplace-production.appspot.com',
  messagingSenderId: '809987214626',
  appId: '1:809987214626:web:7b84cbf8637ff7456de97b',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);

export const functions = getFunctions(app);
export const zoomOAuth = httpsCallable<ZoomOAuthRequest, {success: boolean}>(
  functions,
  'zoomoauth',
);
export const getZoomAccountUsers = httpsCallable<
  GetZoomAccountUsersRequest,
  GetZoomAccountUsersResponse
>(functions, 'getzoomaccountusers');

export interface GenerateTeacherFeedbackRequest {
  courseId: string;
  zoomUserId: string;
  sessionKey: string;
}

export interface GenerateTeacherFeedbackResponse {
  feedbackId: string;
}

export const generateTeacherFeedback = httpsCallable<
  GenerateTeacherFeedbackRequest,
  GenerateTeacherFeedbackResponse
>(functions, 'generateteacherfeedback');

if (import.meta.env.DEV) {
  connectFunctionsEmulator(functions, 'localhost', 5001);
}
